import debounce from 'lodash/debounce';
import { useCallback, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { loadDrivers } from '@/modules/driver/actions/async/loadDrivers';
import { getDrivers } from '@/modules/driver/store/selectors';
import { AppDispatch } from '@/root-store';

import { View } from './view';

interface IProps {
  onNavigate: (url: string) => void;
}

const DriverList = ({ onNavigate }: IProps) => {
  const dispatch: AppDispatch = useDispatch();

  usePermissions('viewDrivers');

  const drivers = useSelector(getDrivers);
  const [isLoading, setIsLoading] = useState(false);

  const handleClickNew = useCallback(() => {
    onNavigate('/add-chauffeur');
  }, [onNavigate]);

  const fetchDrivers = useMemo(
    () =>
      debounce(
        async ({ search = '' }, { limit, offset }) => {
          setIsLoading(true);

          try {
            await dispatch(loadDrivers({ limit, offset, query: search.trim() })).unwrap();
          } finally {
            setIsLoading(false);
          }
        },
        200,
        {
          leading: false,
          trailing: true,
        },
      ),
    [dispatch, setIsLoading],
  );

  return (
    <View
      fetchDrivers={fetchDrivers}
      drivers={drivers}
      onClickNew={handleClickNew}
      isLoading={isLoading}
    />
  );
};

export { DriverList };
